import React from 'react'

// components
import {
  CButton,
  CSpinner
} from '@coreui/react-pro'
import AppModal from '../AppModal'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'

// icons
import CIcon from '@coreui/icons-react'
import { cilWarning } from '@coreui/icons'

// styling
import { styleButtonVars3 } from '../custom-styles/buttonStyles'

const AppModalConfirmation = ({
  confirmationType,
  itemName,
  itemType,
  itemIndex,
  headerTitle,
  showModal,
  setShowModal,
  handleConfirmation,
  handleSubmit,
  descriptionText,
  disabled,
  isLoading,
}) => {
  return (
    <>
      {
        confirmationType === 'delete-item' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you want to delete this ${itemName}?`}
            bodyDescription={`Once confirmed, it can not be undo and all ${itemName} details will be deleted permanently.`}
            className={'text-center'}
            backdrop={'static'}
            isLoading={isLoading ? true : false}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  No
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation(itemIndex, itemType)}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'confirmation' && (
          <AppModal 
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyTitle={descriptionText}
            className={'text-center'}
            modalFooter={
              <>
                <ActionButtonForm 
                  isLoading={isLoading}
                  disabled={disabled}
                  onCancel={() => setShowModal({ show: false, item: {} })}
                  onSave={handleSubmit}
                />
              </>
            }
          />
        )
      }
    </>
  )
}

export default AppModalConfirmation
